//split this off because we don't want it on the content page
//afraid that we might run into conflicts with the content itself
$(window).on('beforeunload', function() {
  document.querySelector('body').className += ' loading';
});
